jQuery(document).ready(function ($) {
	// menu click event
	$('.menuBtn').click(function() {
		$(this).toggleClass('act');
			if($(this).hasClass('act')) {
				$('.main-navigation').addClass('act');
				$('.logo-m').addClass('act');
				$('body').addClass('nav-lock-layer');
			}
			else {
				$('.main-navigation').removeClass('act'); 
				$('.logo-m').removeClass('act'); 
				$('body').removeClass('nav-lock-layer');
			}
	});

	$('.member').click(function() {
		$(this).toggleClass('active');
			if($(this).hasClass('active')) {
				$('.team-mask').addClass('active');
			}
			else {
				$('.team-mask').removeClass('active'); 
			}
	});
	$('.team-mask').click(function() {
		$(this).removeClass('active');
		$('.member').removeClass('active'); 
	});

	$('.slickness').slick({
		dots: true,
		arrows: true,
		infinite: false,
		variableWidth: true,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
		  {
			breakpoint: 1024,
			settings: {
			  slidesToShow: 3
			}
		  },
		  {
			breakpoint: 600,
			settings: {
			  slidesToShow: 2
			}
		  },
		  {
			breakpoint: 480,
			settings: {
			  slidesToShow: 1
			}
		  }
		  // You can unslick at a given breakpoint now by adding:
		  // settings: "unslick"
		  // instead of a settings object
		]
	});

	/* Show Team slick on mobile only */
	$(window).on('load', () => {
		const element = $('.team-list');
		const mediaQuery = window.matchMedia('(max-width: 640px)');
	  
		const handleSwitchSlick = ((e) => {
		  if (e.matches) {
			element.slick({
			  infinite: false,
			  arrows: true,
			  dots: true,
			});
		  } else if (element.hasClass('slick-initialized')) {
			element.slick('unslick');
		  }
		});
	  
		mediaQuery.addListener(handleSwitchSlick);
		handleSwitchSlick(mediaQuery);
	});
	/* end team slick */
	  

	$( ".awsm-job-entry-content" ).append( '<button class="apply">Apply Now</button>' );

	$(".entry-content").on("click", ".apply", function() {
		//$('.awsm-job-entry-content').hide();
		var joburl      = window.location.href;
		$( ".awsm-job-entry-content" ).html( '<a href=" '+joburl+'" class="btn btn-blue">View Details</button>' );
		$('.awsm-job-form').show();
		$("html, body").animate({ scrollTop: 0 }, "slow");
  		return false;
	});


	/*********************************************
	** FLOATING LABELS FOR CF7
	*********************************************/
	$(".wpcf7 .wpcf7-form-control").focus(function(){
		$(this).parent().parent().addClass('active');
	}).blur(function(){
		var cval = $(this).val()
		if(cval.length < 1) {$(this).parent().parent().removeClass('active');}
	})

	/*********************************************
	** FLOATING LABELS FOR GRAVITY
	*********************************************/
	$(".ginput_container input, .ginput_container textarea").focus(function(){
		$(this).parent().parent().addClass('active');
		$(this).parent().addClass('active');
	}).blur(function(){
		var cval = $(this).val()
		if(cval.length < 1) {$(this).parent().parent().removeClass('active');}
		if(cval.length < 1) {$(this).parent().removeClass('active');}
	})
	$(".ginput_container input, .ginput_container textarea").each(function() {
		var loadval = $(this).val()
		if(loadval.length > 1) {$(this).parent().parent().addClass('active')};
		if(loadval.length > 1) {$(this).parent().addClass('active')};
	});
	$(".ginput_container select").each(function() {
		$(this).parent().parent().addClass('active');
		$(this).parent().addClass('active');
	});

/* 4 steps */
	if ($(".percentbar_25")[0]){
		console.log('25');
		$( ".step2, .step3, .step4" ).removeClass( "active" );
		$( ".step1" ).addClass( "active" );
	}
	if ($(".percentbar_50")[0]){
		console.log('50');
		$( ".step1, .step3, .step4" ).removeClass( "active" );
		$( ".step2" ).addClass( "active" );
	}
	if ($(".percentbar_75")[0]){
		console.log('75');
		$( ".step1, .step2, .step4" ).removeClass( "active" );
		$( ".step3" ).addClass( "active" );
	}


	/* 3 steps */
	if ($(".percentbar_33")[0]){
		console.log('33');
		$( ".step2, .step3, .step4" ).removeClass( "active" );
		$( ".step1" ).addClass( "active" );
	}
	if ($(".percentbar_66")[0]){
		console.log('66');
		$( ".step1, .step3, .step4" ).removeClass( "active" );
		$( ".step2" ).addClass( "active" );
	}
	if ($(".percentbar_100")[0]){
		console.log('100');
		$( ".step1, .step2, .step4" ).removeClass( "active" );
		$( ".step3" ).addClass( "active" );
	}


	/** UUID */
	function generateUUID() {
		let d = new Date().getTime();
		const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			const r = (d + Math.random() * 16) % 16 | 0;
			d = Math.floor(d / 16);
			return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
		});
		return uuid;
	};
	/** Create UUID for Enquiry forms */
	const meta_url = $('meta[property="og:url"]').attr('content');
	if(meta_url.indexOf('staging') != -1){
		if($('#input_1_54').length){
			const uuid = generateUUID();
			$('#input_1_54').val(uuid); // (Staging) Enquiry 
		}
	}
	if($('#input_1_50').length){
		const uuid = generateUUID();
		$('#input_1_50').val(uuid); // (Live) Enquiry
	}

	if($('#input_11_50').length){
		const uuid = generateUUID();
		$('#input_11_50').val(uuid); // (Live) HP Direct Enquiry
	}

	if($('#input_3_49').length){
		const uuid = generateUUID();
		$('#input_3_49').val(uuid); // (Staging & Live) Contractor Enquiry 
	}
	


}); 